export enum CrmFilterType {
  EMPLOYER = 'EMPLOYER',
  MEMBER = 'MEMBER',
  MEMBER_AND_EMPLOYER = 'MEMBER_AND_EMPLOYER'
}
